export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учетные формы: Книга учета поступлений документов",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
